import styled, { css } from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './MainOverview.tokens';

export const Section = styled.div`
    display: grid;
    gap: ${tokens.section.gap}px;
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: ${tokens.section.gap}px;
`;

export const SectionTitle = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.section.titleSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

const sectionActionBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.section.actionSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: rgb(255, 255, 255, 0.5);
    border-radius: 4px;
    outline: 2px solid transparent !important;
    outline-offset: 2px;
    transition-property: color, outline-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:focus-visible {
        outline-color: ${designColor.brandPurple} !important;
    }

    &:hover:not(:active) {
        color: rgb(255, 255, 255, 0.8);
    }
`;

export const SectionAction = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    ${sectionActionBase};
`;

///
/// Header

export const HeaderContent = styled.div`
    display: grid;
    gap: ${tokens.header.gap}px;
    text-align: center;
`;

export const Title = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.header.titleSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const Subtitle = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.header.subtitleSize}px;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.2;
    color: rgba(255, 255, 255, 0.5);
`;

///
/// Wallet Options

export const List = styled.ul`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.list.gap}px;
`;

export const Item = styled.li``;
